import { render, staticRenderFns } from "./data88.vue?vue&type=template&id=52831a17&scoped=true&"
import script from "./data88.vue?vue&type=script&lang=js&"
export * from "./data88.vue?vue&type=script&lang=js&"
import style1 from "./data88.vue?vue&type=style&index=1&id=52831a17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52831a17",
  null
  
)

export default component.exports